import { createContext, useContext } from 'react'

export const NodeToolbarHostContext = createContext<{ isExiting: boolean }>({ isExiting: false })

export function useNodeToolbarHostContext() {
  return useContext(NodeToolbarHostContext)
}
